import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import WidgetLayout from './layouts/WidgetLayout';

const WidgetChatPage = lazy(() => import('./pages/WidgetChatPage'));
const DemoHostPage   = lazy(() => import('./pages/DemoHostPage'));

/**
 * Widget route tree.
 * Standalone chat interface — no admin chrome.
 * Accepts agentId + sessionId via URL params or query string.
 *
 * Usage (iframe/link):  /widget/chat?tenantId=...&agentId=...&publishableKey=...
 * Usage (test/demo):    /widget/demo?tenantId=...&agentId=...&publishableKey=...
 */
export const widgetRoutes: RouteObject[] = [
  {
    path: '/widget',
    element: <WidgetLayout />,
    children: [
      { path: 'chat', element: <WidgetChatPage /> },
      { path: 'demo', element: <DemoHostPage /> },
    ],
  },
];
